<template>
  <o-view>
    <o-nav-bar title="Ticket" :has-close-button="true" />
    <o-section> <o-reseller-badge /> </o-section>
  </o-view>
</template>

<script>
export default {
  name: 'KBCConfirmation'
}
</script>
